<template>
    <div></div>
</template>

<script setup lang="ts">
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {ComparisonSectionSlice} from '@prismicio-types';

    defineProps(getSliceComponentProps<ComparisonSectionSlice>(['slice', 'index', 'slices', 'context']));
</script>
